import React from 'react';
import { format, formatDistanceToNow } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock } = FiIcons;

const LastUpdated = ({ timestamp, showSendUpdate = false, onSendUpdate = null }) => {
  if (!timestamp) return null;
  
  const date = new Date(timestamp);
  const formattedDate = format(date, 'MMM dd, yyyy h:mm a');
  const timeAgo = formatDistanceToNow(date, { addSuffix: true });
  
  return (
    <div className="flex items-center justify-between text-xs text-gray-500 mt-2 pt-2 border-t border-gray-100">
      <div className="flex items-center">
        <SafeIcon icon={FiClock} className="w-3 h-3 mr-1" />
        <span>Last updated: {timeAgo} ({formattedDate})</span>
      </div>
      
      {showSendUpdate && onSendUpdate && (
        <button 
          onClick={onSendUpdate}
          className="text-aqua-600 hover:text-aqua-700 font-medium"
        >
          Send Update
        </button>
      )}
    </div>
  );
};

export default LastUpdated;